import { render } from "./TheSheetLower.vue?vue&type=template&id=dc72d9b0"
import script from "./TheSheetLower.vue?vue&type=script&lang=js"
export * from "./TheSheetLower.vue?vue&type=script&lang=js"
script.render = render

export default script